// Extends default Bootstrap tabs to allow deep-linking so that if a page is loaded with a hash
// appended to the URL, this script will attempt to find a .nav-tabs a element with a href
// matching the hash to activate that tab automatically

(function (window, document, $, undefined) {
  "use strict";

  $(document).ready(function () {
    var url = encodeURI(location.href);
    scrollAndActivateRequestedTab(url);

    $('a[data-toggle="tab"]').on("click", function () {
      var hash = encodeURI($(this).attr("href")),
        newUrl = url.split("#")[0] + hash.replace(/[^a-zA-Z0-9-_#]+/g, ""); // regex to remove all non-alphanumeric, dash/hyphen, underscore, and hash characters from the hash

      history.replaceState(null, null, newUrl);
    });

    // This likely won't ever be used but in case the CMS team starts adding URLs to the
    // mega-menu with hashes included, this would allow the tabs to automatically update
    // which was visible if another tab's hash was chosen from the menu for the current
    // page. Requires the .trigger('hashchange') event to actually detect the needed event
    $(window)
      .on("hashchange", function () {
        // resetting url variable to the new value and passing that to the function to
        // change active tab
        url = encodeURI(location.href);
        scrollAndActivateRequestedTab(url);
      })
      .trigger("hashchange");
  });

  $(window).load(function () {
    setTimeout(function () {
      // commenting this out in case this is missed, if you see this after 08/2025 remove.
      //   if (!location.hash) {
      //     window.scrollTo(0, 0);
      //   }
      var $tabToActivate = $('.nav-tabs a[href="' + location.hash + '"');

      // Remove .show from all tabs associated with the hash present in the address bar
      $tabToActivate
        .closest(".nav-tabs")
        .next(".tab-content")
        .find(".tab-pane")
        .removeClass("show");
      // Necessary step, from Bootstrap's documentation
      $tabToActivate.tab("show");
      // Need to show the correct div using the hash present
      $($tabToActivate.attr("href")).show();
      // Need to manually add the class despite .tab('show') supposedly doing this (it doesn't)
      $($tabToActivate.attr("href")).addClass("show");
      // removing the inline style="display: block;" that jQuery .show() adds to prevent the tab content
      // from always showing regardless of the active tab
      $($tabToActivate.attr("href")).removeAttr("style");
    }, 300);
  });

  function scrollAndActivateRequestedTab(url) {
    if (location.hash) {
      var hash = url.split("#");

      $('.nav-tabs a[href="#' + hash[1] + '"').tab("show");

      history.replaceState(null, null, url);
    } // end if (location.hash)
  }
})(window, document, jQuery);
